import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '@shared/api'

export const useAbiturientStore = defineStore('abiturient-form', () => {
  const form = ref({})
  const applications = ref([])
  const abiturient = ref(null)

  const fetchForm = async () => {
    const { data } = await api.get('/api/v1/abiturient/form')
    form.value = data.form
    applications.value = data.applications
  }

  const fetchAbiturient = async () => {
    const { data } = await api.get('/api/v1/abiturient/form/abiturient')
    abiturient.value = data.abiturient
  }

  const searchAbiturient = async (params) => {
    const { data } = await api.post('/api/v1/abiturient/form/abiturient', { abiturient: params })
    abiturient.value = data.abiturient
  }

  const createForm = async (params) => {
    const { data } = await api.post('/api/v1/abiturient/form', params)
    if (data.form) form.value = data.form
  }

  const updateForm = async (params) => {
    const { data } = await api.patch('/api/v1/abiturient/form', params)
    if (data.form) form.value = data.form
  }

  return { form, applications, abiturient, fetchForm, fetchAbiturient, searchAbiturient, createForm, updateForm }
})
